export const DASHBOARD_TAB_PARAM = "tab";
export const LESSON_CONFIG_TAB = "lessonconfig";
export const LESSON_ID_PARAM = "lesson_id";

export const parseLessonIdParam = (value: string | null): number | null => {
  if (!value) return null;

  const parsed = Number.parseInt(value, 10);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
};

export const buildDashboardTabSearchParams = (
  current: URLSearchParams,
  tab: string,
): URLSearchParams => {
  const next = new URLSearchParams(current);
  next.set(DASHBOARD_TAB_PARAM, tab);

  if (tab !== LESSON_CONFIG_TAB) {
    next.delete(LESSON_ID_PARAM);
  }

  return next;
};

export const buildLessonConfigSearchParams = (
  current: URLSearchParams,
  lessonId: number | null,
): URLSearchParams => {
  const next = buildDashboardTabSearchParams(current, LESSON_CONFIG_TAB);

  if (lessonId == null) {
    next.delete(LESSON_ID_PARAM);
  } else {
    next.set(LESSON_ID_PARAM, String(lessonId));
  }

  return next;
};
